export enum ErrorUnavailableEnum {
	INSUFFICIENT_BALANCE = "saldo-insuficiente",
	CONTRACT_UNAVAILABLE= "contratação-indisponivel",
	KEY_PIX_UNAVAILABLE= "chave-pix-incorreta",
}
